import React from "react";
import { Phone, WhatsappLogo, ChatCircleText } from "@phosphor-icons/react";
import { useBooking } from "@/context/BookingContext";

export function StickyMobileCTA() {
  const { open, isOpen } = useBooking();

  if (isOpen) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[8000] grid grid-cols-3 border-t border-white/10 bg-ink/95 backdrop-blur-lg md:hidden" data-testid="sticky-mobile-cta">
      <button type="button" disabled aria-label="Call coming soon" data-testid="mobile-call" className="flex cursor-not-allowed flex-col items-center gap-1 py-3 text-white/35">
        <Phone size={20} className="text-gold/55" />
        <span className="text-[10px] uppercase tracking-wider">Call</span>
        <span className="text-[8px] uppercase tracking-wider text-gold/70">Coming Soon</span>
      </button>
      <button type="button" disabled aria-label="WhatsApp coming soon" data-testid="mobile-whatsapp" className="flex cursor-not-allowed flex-col items-center gap-1 border-x border-white/10 py-3 text-white/35">
        <WhatsappLogo size={20} className="text-gold/55" />
        <span className="text-[10px] uppercase tracking-wider">WhatsApp</span>
        <span className="text-[8px] uppercase tracking-wider text-gold/70">Coming Soon</span>
      </button>
      <button onClick={() => open("enquiry")} data-testid="mobile-enquire" className="flex flex-col items-center gap-1 py-3 text-white/80 active:bg-white/5">
        <ChatCircleText size={20} className="text-gold" />
        <span className="text-[10px] uppercase tracking-wider">Enquire</span>
      </button>
    </div>
  );
}
